module.exports = __webpack_public_path__ + "static/carbon-table-pagination-ab2517901e47c8a7d9b3154807ae1258.png";